import { request } from "../../platform/apiClient/apiRequest";
import type { Benefit, BenefitPatch } from "../types/benefit.types";
import type { BenefitAttachment } from "../types/benefitAttachment.types";

export interface BenefitInput {
  category: string;
  merchant: string;
  offerText: string;
  details?: string;
  imageUrl?: string;
  validFrom?: string | null;
  validTo?: string | null;
  isActive?: boolean;
}

export const benefitsClient = {
  getBenefits: () => request<Benefit[]>("/benefits"),

  getAdminBenefits: () => request<Benefit[]>("/benefits/admin"),

  createBenefit: (input: BenefitInput) =>
    request<Benefit>("/benefits/admin", {
      method: "POST",
      body: JSON.stringify(input),
    }),

  updateBenefit: (id: string, patch: BenefitPatch) =>
    request<Benefit>(`/benefits/admin/${encodeURIComponent(id)}`, {
      method: "PATCH",
      body: JSON.stringify(patch),
    }),

  deleteBenefit: (id: string) =>
    request<void>(`/benefits/admin/${encodeURIComponent(id)}`, { method: "DELETE" }),

  uploadAttachment: (benefitId: string, file: File) =>
    request<BenefitAttachment>(
      `/benefits/admin/${encodeURIComponent(benefitId)}/attachments?filename=${encodeURIComponent(file.name)}`,
      {
        method: "POST",
        headers: { "Content-Type": file.type || "application/octet-stream" },
        body: file,
      },
    ),

  removeAttachment: (attachmentId: string) =>
    request<void>(`/benefits/admin/attachments/${encodeURIComponent(attachmentId)}`, { method: "DELETE" }),

  uploadLogo: (id: string, file: File) =>
    request<Benefit>(`/benefits/admin/${encodeURIComponent(id)}/logo?filename=${encodeURIComponent(file.name)}`, {
      method: "PUT",
      headers: { "Content-Type": file.type || "application/octet-stream" },
      body: file,
    }),

  removeLogo: (id: string) =>
    request<Benefit>(`/benefits/admin/${encodeURIComponent(id)}/logo`, { method: "DELETE" }),
};

/** Direct download link — not fetched via JS, used as an <a href>. */
export function attachmentDownloadUrl(attachmentId: string): string {
  return `/api/benefits/attachments/${encodeURIComponent(attachmentId)}/file`;
}

/** Direct image src — not fetched via JS, used as an <img src>. */
export function logoUrl(id: string): string {
  return `/api/benefits/${encodeURIComponent(id)}/logo`;
}
